import React from 'react';
import type { AIChatMode } from './types';
import { CardSelector } from '../cards';
import { ModeToggleWrapper } from './AIChat.Styled';

export type AIChatModeToggleProps = {
	modes: AIChatMode[];
	activeModeId?: string;
	onModeChange?: (modeId: string) => void;
};

export function AIChatModeToggle({
	modes,
	activeModeId,
	onModeChange,
}: AIChatModeToggleProps): React.ReactElement {
	const options = modes.map(mode => ({
		value: mode.id,
		label: mode.label,
		graphic: mode.icon,
	}));

	return (
		<ModeToggleWrapper>
			<CardSelector
				options={options}
				selectedId={activeModeId}
				onSelected={onModeChange ?? (() => undefined)}
			/>
		</ModeToggleWrapper>
	);
}
